module.exports = "https://static.zego.com/_next/static/images/easy-admin-deee555cca3d895196869b51b79ccc98.png";